const MARGIN = 8;
const MAX_HEIGHT = 300;

export interface DropdownPositionConfig {
  minWidth?: number;
  includeWidth?: boolean;
}

export function calculateDropdownStyle(
  rect: DOMRect,
  config: DropdownPositionConfig = {}
): { [key: string]: string } {
  const { minWidth, includeWidth = true } = config;

  const spaceBelow = window.innerHeight - rect.bottom - MARGIN;
  const spaceAbove = rect.top - MARGIN;
  const openUpward = spaceBelow < MAX_HEIGHT && spaceAbove > spaceBelow;

  const availableSpace = openUpward ? spaceAbove : spaceBelow;
  const maxHeight = Math.min(MAX_HEIGHT, availableSpace);

  const verticalStyle = openUpward
    ? { top: 'auto', bottom: `${window.innerHeight - rect.top}px` }
    : { top: `${rect.bottom}px`, bottom: 'auto' };

  const referenceWidth = minWidth ?? rect.width;
  const spaceOnRight = window.innerWidth - rect.left;
  const horizontalStyle =
    spaceOnRight >= referenceWidth
      ? { left: `${rect.left}px`, right: 'auto' }
      : { right: `${window.innerWidth - rect.right}px`, left: 'auto' };

  return {
    position: 'fixed',
    ...(minWidth != null && { minWidth: `${minWidth}px` }),
    ...(includeWidth && { width: `${rect.width}px` }),
    maxHeight: `${maxHeight}px`,
    ...verticalStyle,
    ...horizontalStyle,
  };
}
